/**
* 社区玩具帖子
*/
<template>
	<body style="max-width: 400px; margin: 0 auto;">

		<!-- 打开QIUI 没有打开成功 就跳转其他页面 -->
		<van-overlay :show="loading" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000002') }}</van-loading>
			</div>
		</van-overlay>


		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>


		<!-- 打开QIUI -->
		<div class="open-qiui-div-bg-community_toys" @click="openQIUI">
			<div class="open-qiui-div-button-community_toys">
				<img style="width: 30px; height: 30px;" src="../assets/main03_sys.jpg">
				<span class="open-qiui-div-span-community_toys">{{ $t('language000039') }}</span>
				<img style="width: 13px; height: 13px;" src="../assets/right_grey.png" />
			</div>
		</div>

		<!-- 标题 公投帖-->
		<div style="text-align: center; margin-top: 15px; margin-bottom: 15px;">
			<span style="font-size: 18px; font-weight: bold; color: black;">{{ titleBar }}</span>
		</div>


		<!-- 用户资料 -->
		<div style="height: 50px; display: flex; align-items: center; padding: 0 10px;">
			<div>
				<van-image round width="45px" height="45px" :src="avatar" />
			</div>
			<div style="margin-left: 8px; height: 100%; margin-top: 2px;">
				<div style="text-align: left;">
					<span
						style="margin-left: 3px; font-size: 14px; font-weight: bold; color: #000;">{{ nickName }}</span>
				</div>
				<div style="display: flex; align-items: center; margin-top: 4px;">
					<div :style="{ 'background-color': sexBackgroundColor }"
						style="border-radius: 10px; padding: 2px 6px; display: flex; align-items: center;">
						<img style="width: 13px; height: 13px;" :src="sexImage">
						<span :style="{'color':sexTextColor }"
							style="font-size: 11px; margin-left: 3px; font-weight: bold;">{{ age }}</span>
					</div>
					<span style=" padding: 0 5px; font-size: 11px; font-weight: bold; color: #999;">/</span>
					<span style=" font-size: 11px; font-weight: bold; color: #999;">{{ sexOrientation }}</span>
					<span style=" padding: 0 5px; font-size: 11px; font-weight: bold; color: #999;">/</span>
					<span style=" font-size: 11px; font-weight: bold; color: #999;">{{ attribute }}</span>
				</div>
			</div>
		</div>


		<!-- 帖子的内容 -->
		<div style="padding: 0 15px;margin-top: 10px;">
			<span style="font-size: 14px;">{{ topicContent }}</span>
		</div>


		<!-- 发帖时间+多少人参与了 -->
		<div style="display: flex; align-items: center; margin-top: 10px; padding: 0 15px;">

			<!-- 发帖时间 -->
			<span style="flex: 1;text-align: left; font-size: 11px; color: #999;">{{ postTime }}</span>

			<van-image v-if="participantIsShowImage01" round width="20px" height="20px" :src="participantImage01" />

			<van-image v-if="participantIsShowImage02" round width="20px" height="20px" style="margin-left: -5px;"
				:src="participantImage02" />

			<van-image v-if="participantIsShowImage03" round width="20px" height="20px" style="margin-left: -5px;"
				:src="participantImage03" />

			<span
				style="margin-left: 5px; font-size: 11px; color: #FD451A;">{{ $t('language000047') }}{{ numberPeople }}{{ $t('language000048') }}</span>
			<img style="width: 10px; height: 10px; margin-left: 5px;" src="../assets/right_grey.png" />
		</div>


		<!-- 参与条件 -->
		<div style="display: flex; align-items: center; margin-top: 10px; padding: 0 15px;">
			<img style="width: 16px;  height: 16px;" src="../assets/participation_conditions.png" />
			<span style="margin-left: 10px; font-size: 15px; color: #333333;">{{ $t('language000031')}}</span>
		</div>

		<!-- 国家及地区 -->
		<div style="display: flex; align-items: center; margin-top: 10px; padding: 0 15px;">
			<span class="span-condition-commodity_toys-01">{{ $t('language000032')}}</span>
			<span class="span-condition-commodity_toys-02">{{ conditionCountry }}</span>
		</div>

		<!-- 性别 -->
		<div style="display: flex; align-items: center; margin-top: 10px; padding: 0 15px;">
			<span class="span-condition-commodity_toys-01">{{ $t('language000033')}}</span>
			<span class="span-condition-commodity_toys-02">{{ conditionSex }}</span>
		</div>

		<!-- 属性 -->
		<div style="display: flex; align-items: center; margin-top: 10px; padding: 0 15px;">
			<span class="span-condition-commodity_toys-01">{{ $t('language000034')}}</span>
			<span class="span-condition-commodity_toys-02">{{ conditionAttribute }}</span>
		</div>

		<!-- 年龄 -->
		<div style="display: flex; align-items: center; margin-top: 10px; padding: 0 15px;">
			<span class="span-condition-commodity_toys-01">{{ $t('language000035')}}</span>
			<span class="span-condition-commodity_toys-02">{{ conditionAge }}</span>
		</div>

		<!-- 性取向 -->
		<div style="display: flex; align-items: center; margin-top: 10px; padding: 0 15px;">
			<span class="span-condition-commodity_toys-01">{{ $t('language000036')}}</span>
			<span class="span-condition-commodity_toys-02">{{ conditionSexOrientation }}</span>
		</div>

		<!-- 结束时间 -->
		<div style="display: flex; align-items: center; margin-top: 10px; padding: 0 15px;">
			<span class="span-condition-commodity_toys-01">{{ $t('language000037')}}</span>
			<span class="span-condition-commodity_toys-02" style="color: #AA0238;">{{ voteLastTime }}</span>
		</div>

		<!-- 每票时长 -->
		<div style="display: flex; align-items: center; margin-top: 10px; padding: 0 15px;">
			<span class="span-condition-commodity_toys-01">{{ timeType }}</span>
			<span class="span-condition-commodity_toys-02" style="color: #AA0238;">{{ voteLockTime }}</span>
		</div>

		<!-- 当前投票时间 -->
		<div style="display: flex; align-items: center; margin-top: 10px; padding: 0 15px;">
			<span class="span-condition-commodity_toys-01">{{ $t('language000067') }}</span>
			<span class="span-condition-commodity_toys-02" style="color: #AA0238;">{{ totalVoteDuration }}</span>
		</div>

		<!-- PK进度条 -->
		<div v-if="gen3IsShow01" class="pk-container" style="margin-top: 10px; padding: 0 10px;">
			<div class="pk-bar">
				<div :style="{ width: barWidthA }" class="pk-bar-section section-a" style="min-width: 65px;">
					<p>{{$t('language000066')}}:{{ votesA }}</p>
				</div>
				<div :style="{ width: barWidthB }" class="pk-bar-section section-b"
					style="justify-content: flex-end; min-width: 65px;">
					<p>{{ votesB }}:{{$t('language000066')}}</p>
				</div>
			</div>
		</div>

		<!-- 我要投票 -->
		<div v-if="isVote" class="span-button-commodity_toys-vote" @click="openQIUI()">
			<span>{{ voteButton }}</span>
		</div>

		<!-- 已结束的按钮 -->
		<div v-if="isEnd" class="span-button-end-commodity_toys-vote">
			<span>{{ $t('language000055') }}</span>
		</div>

		<!-- 三代锁投票按钮 -->
		<div v-if="gen3IsShow02" style="display: flex; justify-content: space-between;">
			<button class="span-button-commodity_toys-vote-gen3" @click="touristsVote(1)">
				-{{ visitorsVoteReduceLockTime }}
			</button>
			<button class="span-button-commodity_toys-vote-gen3" @click="touristsVote(0)">
				+{{ visitorsVoteLockTime }}
			</button>
		</div>


		<!-- 评论列表 -->
		<div style="padding: 15px 10px;">
			<ul>
				<li v-for="(comment, index) in toyTopicComments" :key="index">
					<!-- 评论人 -->
					<div style="height: 50px; display: flex; align-items: center;">
						<!-- 头像 -->
						<div>
							<van-image round width="45px" height="45px"
								:src="getAvatarSrc(comment.commentUserDetail.avatar)" />
						</div>
						<!-- 昵称+发布时间+点赞数 -->
						<div style="margin-left: 10px; width: 100%;">
							<div>
								<span
									style="font-size: 13px; color: #666;">{{ comment.commentUserDetail.nickName }}</span>
							</div>
							<div>
								<span
									style="font-size: 11px; color: #999;">{{ timeConversion(comment.postTime) }}</span>
								<div style="float: right; margin-top: -5px; display: flex; align-items: center;">
									<img style="width: 17px; height: 15px;" src="../assets/post_collection_no.png" />
									<span
										style="margin-left: 2px; font-size: 13px; color: #999;">{{ comment.likeCount }}</span>
								</div>
							</div>
						</div>
					</div>
					<div style="display: flex; padding: 5px 0;">
						<!-- 楼层 -->
						<span
							style="width: 45px; font-size: 12px; color: #999; text-align: center;">{{ index+1 }}L</span>
						<!-- 评论内容 -->
						<span style="font-size: 14px; color: #333;">{{ comment.commentContent }}</span>
					</div>
					<!-- 线 -->
					<div
						style="margin-left: 45px; margin-right: 5px; border-bottom: 1px solid #F6F7F8; margin: 10px 0;">
					</div>

				</li>
			</ul>
		</div>

		<!-- //.. -->

	</body>
</template>

<script>
	//执行顺序是beforeCreate -> created -> beforeMount -> mounted
	import axios from 'axios';

	import 'vant/lib/index.css'; //导入样式
	import Vue from 'vue';
	import {
		Image as VanImage
	} from 'vant';
	Vue.use(VanImage);

	// 引入公用方法
	import {
		getAttributeConversion,
		getSexOrientations
	} from '@/utils/StringUtil';


	export default {
		computed: {
			totalVotes() {
				return this.votesA + this.votesB;
			},
			barWidthA() {
				return this.totalVotes === 0 ? '0%' : `${(this.votesA / this.totalVotes) * 100}%`;
			},
			barWidthB() {
				return this.totalVotes === 0 ? '0%' : `${(this.votesB / this.totalVotes) * 100}%`;
			}
		},
		mounted() {
			// 在生命周期钩子中获取路由参数
			this.param1 = this.$route.params.param1;
			this.param2 = this.$route.params.param2;

			const userLanguage = navigator.language || navigator.userLanguage;
			const isLanguageSupported = this.$p_languages.includes(userLanguage);
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;
			//this.$i18n.locale = "en";

			this.fetchData();
		},
		data() {
			return {
				loading: false, // 是否显示加载效果 （打开qiui）
				loadingData: false, // 是否显示加载效果 (加载数据)
				param1: null, //路由参数1
				param2: null, //路由参数2
				avatar: this.$p_urlHead, //用户头像
				nickName: "", //用户昵称
				age: null, //年龄
				sexOrientation: null, //性取向
				attribute: null, //属性
				topicContent: null, //帖子内容
				sexBackgroundColor: "", //性别背景颜色
				sexImage: "", //性别背景
				sexTextColor: "", //性别年龄的文字颜色
				postTime: null, //发布时间
				participantIsShowImage01: false, //是否显示这个控件
				participantIsShowImage02: false, //是否显示这个控件
				participantIsShowImage03: false, //是否显示这个控件
				participantImage01: this.$p_urlHead, //参与人图片
				participantImage02: this.$p_urlHead, //参与人图片
				participantImage03: this.$p_urlHead, //参与人图片
				numberPeople: 0, //参与人数
				conditionCountry: "", //国家及地区条件
				conditionSex: "", //性别条件
				conditionAttribute: "", //属性条件
				conditionAge: "", //年龄条件
				conditionSexOrientation: "", //性取向条件
				voteLastTime: "", //结束时间
				titleBar: "", //什么类型的帖子
				timeType: "", //每票时长
				voteLockTime: "", //QIUI用户每票增加时长
				voteReduceLockTime: "", //QIUI用户每票减少时长
				voteButton: "", //投票按钮显示的文案
				toyTopicComments: [], //评论数据
				isVote: false, //是否显示投票
				isEnd: false, //是否显示已结束
				votesA: 0, //投票减少票数
				votesB: 0, //投票增加票数
				totalVoteDuration: "", //当前帖子投票后的时间
				visitorsVoteLockTime: "", //访客每票锁定时长
				visitorsVoteReduceLockTime: "", //访客每票减少锁定时长
				gen3IsShow01: "", //是否显示投票进度条,
				gen3IsShow02: "", //是否显示投票按钮
			};
		},
		methods: {
			fetchData() {
				this.loadingData = true;
				axios.post(this.$p_url + '/feign/spread/getSpreadToyTopicDetail', {
						uid: this.param1,
						userId: this.param2,
					}, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("返回的值：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							const data = response.data.data; // 获取数据
							//用户数据
							const userDetail = data.userDetail;
							this.nickName = userDetail.nickName;
							if (userDetail.avatar === undefined) {
								this.avatar = this.$p_urlHead
							} else
								this.avatar = this.$p_urlImage + userDetail.avatar;
							this.age = userDetail.age; //年龄
							switch (this.sex) { //性别背景
								case 1:
									this.sexBackgroundColor = "#9BDFFC";
									this.sexImage = require('@/assets/sex01.png');
									this.sexTextColor = "#02A1FC";
									break
								case 2:
									this.sexBackgroundColor = "#FED7D7";
									this.sexImage = require('@/assets/sex02.png');
									this.sexTextColor = "#FC5E5E";
									break
								case 3:
									this.sexBackgroundColor = "#BEB5FC";
									this.sexImage = require('@/assets/sex03.png');
									this.sexTextColor = "#4A418C";
									break
								case 4:
									this.sexBackgroundColor = "#FBCE9A";
									this.sexImage = require('@/assets/sex04.png');
									this.sexTextColor = "#FA8F14";
									break
								default:
									this.sexBackgroundColor = "#A7F8D8";
									this.sexImage = require('@/assets/sex05.png');
									this.sexTextColor = "#0DBB76";
									break
							}


							switch (userDetail.sexOrientation) { //性取向
								case 1: //Bis
									this.sexOrientation = "BIS";
									break;
								case 2: //Hetero
									this.sexOrientation = "HETERO";
									break;
								case 3: //Gay
									this.sexOrientation = "GAY";
									break;
								case 4: //LES
									this.sexOrientation = "LES";
									break;
							}

							this.attribute = getAttributeConversion(userDetail.attribute.toString()); //属性


							this.topicContent = data.topicContent; //帖子内容
							this.postTime = this.timeConversion(data.postTime); //发布时间


							if (data.toyTopicVoteUsers != null) {
								this.numberPeople = data.toyTopicVoteUsers.length; //多少人参与帖子

								if (data.toyTopicVoteUsers.length >= 3) { //根据参与的人展示三个，两个，一个头像
									this.participantIsShowImage01 = true;
									this.participantIsShowImage02 = true;
									this.participantIsShowImage03 = true;
									if (data.toyTopicVoteUsers[0].voteSmallUser.avatar === undefined) {
										this.participantImage01 = this.$p_urlHead
									} else this.participantImage01 = this.$p_urlImage + data.toyTopicVoteUsers[0]
										.voteSmallUser.avatar;

									if (data.toyTopicVoteUsers[1].voteSmallUser.avatar === undefined) {
										this.participantImage02 = this.$p_urlHead
									} else this.participantImage02 = this.$p_urlImage + data.toyTopicVoteUsers[1]
										.voteSmallUser.avatar;

									if (data.toyTopicVoteUsers[2].voteSmallUser.avatar === undefined) {
										this.participantImage03 = this.$p_urlHead
									} else this.participantImage03 = this.$p_urlImage + data.toyTopicVoteUsers[2]
										.voteSmallUser.avatar;

								} else if (data.toyTopicVoteUsers.length == 2) {
									this.participantIsShowImage01 = true;
									this.participantIsShowImage02 = true;
									this.participantIsShowImage03 = false;
									if (data.toyTopicVoteUsers[0].voteSmallUser.avatar === undefined) {
										this.participantImage01 = this.$p_urlHead
									} else this.participantImage01 = this.$p_urlImage + data.toyTopicVoteUsers[0]
										.voteSmallUser.avatar;

									if (data.toyTopicVoteUsers[1].voteSmallUser.avatar === undefined) {
										this.participantImage02 = this.$p_urlHead
									} else this.participantImage02 = this.$p_urlImage + data.toyTopicVoteUsers[1]
										.voteSmallUser.avatar;

								} else if (data.toyTopicVoteUsers.length == 1) {
									this.participantIsShowImage01 = true;
									this.participantIsShowImage02 = false;
									this.participantIsShowImage03 = false;
									if (data.toyTopicVoteUsers[0].voteSmallUser.avatar === undefined) {
										this.participantImage01 = this.$p_urlHead
									} else this.participantImage01 = this.$p_urlImage + data.toyTopicVoteUsers[0]
										.voteSmallUser.avatar;
								}
							}


							//条件 国家及地区
							if (data.toyPlayConditionDetail.countrys.length == 1 &&
								data.toyPlayConditionDetail.countrys[0] == "0") {
								this.conditionCountry = this.$t('language000065');
							} else {
								data.toyPlayConditionDetail.countrys.forEach((item, index) => {
									this.conditionCountry = this.conditionCountry + " " + item;
								});
							}

							//条件 性别
							this.conditionSex = "";
							data.toyPlayConditionDetail.sexs.forEach((item, index) => {
								this.conditionSex = this.conditionSex + ' ' + this.sexConversion(item);
							});

							//条件 属性
							this.conditionAttribute = "";
							data.toyPlayConditionDetail.attributes.forEach((item, index) => {
								this.conditionAttribute = this.conditionAttribute + ' ' +
									getAttributeConversion(item);
							});

							//条件 年龄
							this.conditionAge = "";
							data.toyPlayConditionDetail.ages.forEach((item, index) => {
								this.conditionAge = this.conditionAge + '~' + item
							});
							this.conditionAge = this.conditionAge.slice(1)

							//条件 性取向
							this.conditionSexOrientation = "";
							data.toyPlayConditionDetail.sexOrientations.forEach((item, index) => {
								this.conditionSexOrientation = this.conditionAttribute + ' ' +
									getSexOrientations(item);
							});

							//每票时长
							if (data.status == 2) {
								this.voteLastTime = this.$t('language000055');
							} else {
								if (data.voteLastTime > 60) {
									let i = Math.round(data.voteLastTime / 60);
									this.voteLastTime = (i <= 0 ? "1" : i) + this.$t('language000056');
								} else {
									this.voteLastTime = data.voteLastTime + this.$t('language000057');
								}
							}

							//根据帖子类型进行显示
							switch (data.type) {
								case 0: //公投贴
									this.titleBar = this.$t('language000030');
									this.timeType = this.$t('language000038');
									//每票增加时间
									if (data.toyPlayConditionDetail.voteLockTime === undefined) {
										this.voteLockTime = "0" + this.$t('language000060');
									} else {
										this.voteLockTime = data.toyPlayConditionDetail.voteLockTime + this.$t(
											'language000060');
									}
									this.voteButton = this.$t('language000061');
									if (data.status == 2) {
										this.isVote = false;
										this.isEnd = true;
									} else {
										this.isVote = true;
										this.isEnd = false;
									}
									this.gen3IsShow01 = false;
									this.gen3IsShow02 = false;
									break
								case 1: //寻主贴
									this.titleBar = this.$t('language000058');
									this.timeType = this.$t('language000059');
									//每票增加时间
									if (data.toyPlayConditionDetail.voteLockTime === undefined) {
										this.voteLockTime = "0" + this.$t('language000060');
									} else {
										this.voteLockTime = data.toyPlayConditionDetail.voteLockTime + this.$t(
											'language000060');
									}
									this.voteButton = this.$t('language000062');
									if (data.status == 2) {
										this.isVote = false;
										this.isEnd = true;
									} else {
										this.isVote = true;
										this.isEnd = false;
									}
									this.gen3IsShow01 = false;
									this.gen3IsShow02 = false;
									break
								case 2: //三代锁 公投贴
									this.isVote = false;
									this.isEnd = false;
									this.gen3IsShow01 = true;
									this.gen3IsShow02 = true;
									this.titleBar = this.$t('language000030');
									this.timeType = this.$t('language000038');
									//QIUI每票增加时间
									if (data.toyPlayConditionDetail.voteLockTime === undefined) {
										this.voteLockTime = "0" + this.$t('language000060');
									} else {
										this.voteLockTime = data.toyPlayConditionDetail.voteLockTime + this.$t(
											'language000060');
									}

									//每票增加时间
									if (data.toyPlayConditionDetail.visitorsVoteLockTime === undefined) {
										this.visitorsVoteLockTime = "0" + this.$t('language000060');
									} else {
										this.visitorsVoteLockTime = data.toyPlayConditionDetail.visitorsVoteLockTime +
											this.$t(
												'language000060');
									}
									//每票减少时间
									if (data.toyPlayConditionDetail.visitorsVoteReduceLockTime === undefined) {
										this.visitorsVoteReduceLockTime = "0" + this.$t('language000060');
									} else {
										this.visitorsVoteReduceLockTime = data.toyPlayConditionDetail
											.visitorsVoteReduceLockTime + this
											.$t('language000060');
									}

									//当前投票的时间
									if (data.totalVoteDuration === undefined) {
										this.totalVoteDuration = "0" + this.$t('language000060');
									} else {
										this.totalVoteDuration = data.totalVoteDuration + this.$t('language000060');
									}


									this.votesA = data.userReduceVoteCount + data.visitorsReduceVoteCount; //负投票
									this.votesB = data.userPlusVoteCount + data.visitorsPlusVoteCount; //正投票

									if (data.allowVisitorsVoteFlag == 0) { //是否允许游客投票 0不允许 1允许										
										this.gen3IsShow02 = false;
									}
									break
							}

							//评论
							this.toyTopicComments = data.toyTopicComments;


						} else { // 处理状态为失败的情况
							this.loadingData = false;
							console.error('请求失败:', response.data.data);
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						console.error('Error fetching data:', error);
					});
			},
			timeConversion(time) { //时间转换处理
				const s = time.split("_");
				switch (s[1]) {
					case "s":
						s[1] = this.$t('language000041');
						break;
					case "m":
						s[1] = this.$t('language000042');
						break;
					case "h":
						s[1] = this.$t('language000043');
						break;
					case "d":
						s[1] = this.$t('language000044');
						break;
					case "M":
						s[1] = this.$t('language000045');
						break;
					case "y":
						s[1] = this.$t('language000046');
						break;
				}
				return s[0] + " " + s[1];
			},
			sexConversion(type) { //性别
				let attribute = "";
				switch (type) {
					case "1": // 1:男
						attribute = "MALE";
						break;
					case "2": // 2:女
						attribute = "FEMALE";
						break;
					case "3": // 3:SISSY
						attribute = "SISSY";
						break;
					case "4": // 4:MTF
						attribute = "MTF";
						break;
					case "5": //5:FTM
						attribute = "FTM";
						break;
					default:
						attribute = "";
				}
				return attribute;
			},
			getAvatarSrc(avatar) {
				// 在这里进行字符串拼接
				return this.$p_urlImage + avatar;
			},
			openQIUI() { // 在这里可以添加打开 QIUI 的逻辑
				const a = document.createElement("a");
				a.href = this.$p_urlScheme + "postToysinfo?uid=" + this.param1;

				this.loading = true; //显示加载中
				const u = navigator.userAgent;
				const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
				if (isiOS) { //IOS
					window.location.href = this.$p_urlScheme + "postToysinfo?uid=" + this.param1; // ios对应的app协议
					setTimeout(() => {
						this.loading = false;
						//检测页面是否隐藏，通常用于判断用户是否切换到其他应用或标签。
						let hidden = window.document.hidden || window.document.mozHidden || window.document
							.msHidden || window.document.webkitHidden
						//如果页面未隐藏，表示用户留在当前页面。
						if (typeof hidden == "undefined" || hidden == false) {

							/* //跳转到注册页面
							this.$router.push({
								name: 'register'
							}); */

							//跳转到下载页面
							this.$router.push({
								name: 'download'
							});

						}
					}, 3000); //延迟3秒执行
				} else { //Android
					window.location.href = this.$p_urlScheme + "postToysinfo?uid=" + this.param1; // 安卓对应的app协议
					
					console.error('href:', window.location.href);
					console.error('topicId:', this.param1);
					
					setTimeout(() => {
						let hidden = window.document.hidden || window.document.mozHidden || window.document
							.msHidden || window.document.webkitHidden
						if (typeof hidden == "undefined" || hidden == false) {
							this.loading = false;

							/* //跳转到注册页面
							this.$router.push({
								name: 'register'
							}); */

							//跳转到下载页面
							this.$router.push({
								name: 'download'
							});

						}
					}, 3000); //延迟3秒执行
				}
			},
			touristsVote(type) { //type 0正向投票 1负向投票
				this.loadingData = true;
				axios.post(this.$p_url + '/feign/spread/visitorsVote', {
						toyTopicId: this.param1,
						userId: this.param2,
						reduceFlag: type,
					}, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("投票返回的值：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							this.fetchData();
						} else { // 处理状态为失败的情况
							this.loadingData = false;
							switch (response.data.data) {
								case "toy_100067": //投票已经结束
									alert(this.$t('language000068'));
									break
								case "toy_100203": //访客无法投票
									alert(this.$t('language000069'));
									break
								case "toy_100204": //不可以重复投票
									alert(this.$t('language000070'));
									break
								default:
									alert("请求失败:" + response.data.data);
									break
							}

						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						console.error('Error fetching data:', error);
					});
			},
		},
		//...
	}
</script>

<style>
	/* 引入外部的CSS文件 */
	@import '../css/community_toys.css';

	pk-container {
		width: 100%;
		text-align: center;
	}

	.pk-bar {
		display: flex;
		overflow: hidden;
		border-radius: 5px;
		/* 添加圆角 */
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
		/* 添加阴影效果 */
	}

	.pk-bar-section {
		height: 30px;
		display: flex;
		align-items: center;
		color: #fff;
		font-weight: bold;
		transition: width 0.3s ease;
		/* 添加过渡效果 */
	}

	.section-a {
		background-color: #3498db;
		transition: background-color 0.3s ease;
		/* 添加过渡效果 */
	}

	.section-b {
		background-color: #e74c3c;
		transition: background-color 0.3s ease;
		/* 添加过渡效果 */
	}

	.pk-bar-section p {
		margin: 0;
		padding: 0 5px;
		font-size: 11px;
	}

	.advantage {
		opacity: 0.8;
		/* 增加优势时的透明度 */
	}
</style>